import { Component, OnDestroy, OnInit } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { SEOService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { GuideRoutingService } from '../service/guide-routing.service'

@Component({
  selector: 'flowaccount-guide-page',
  templateUrl: './guide-page.component.html',
  styleUrls: ['./guide-page.component.scss'],
})
export class GuidePageComponent implements OnInit, OnDestroy {
  public ngUnSubScribe = new Subject()
  constructor(
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private guideRoutingService: GuideRoutingService,
    private meta: Meta,
    private titleService: Title,
    private seoService: SEOService,
  ) {
    this.dynamicMetaTag()
    this.translate.onLangChange.pipe(takeUntil(this.ngUnSubScribe)).subscribe(() => {
      this.dynamicMetaTag()
    })
  }

  ngOnInit() {
    this.translate.onLangChange.pipe(takeUntil(this.ngUnSubScribe)).subscribe((lang) => {
      const currentPath = window.location.pathname //อะไรก็ได้ที่เป็น url this.route.snapshot.url
      // console.log('hello' + this.route.snapshot.url)
      if (lang.lang === 'th' && currentPath.startsWith('/en')) {
        const newUrl = currentPath.replace('/en', '/')
        this.router.navigateByUrl(newUrl)
      } else if (lang.lang === 'en' && !currentPath.startsWith('/en')) {
        const newUrl = `/en/${currentPath}`
        this.router.navigateByUrl(newUrl)
      }
    })
  }

  dynamicMetaTag() {
    const canonicalUrl = 'https://flowaccount.com/blog/'
    this.guideRoutingService.getCurrent().subscribe((route) => {
      if (route.tagTitle && route.metaTitle) {
        this.titleService.setTitle(route.tagTitle)
        this.meta.updateTag({ name: 'title', content: route.metaTitle })
        this.seoService.setCanonicalUrl(canonicalUrl)

        if (route.metaDescription) {
          const translatedMetaDescription = this.translate.instant(route.metaDescription)
          this.meta.updateTag({ name: 'description', content: translatedMetaDescription })

          this.seoService.createOg(
            'https://flowaccountcdn.com/images/Thumnail_FlowPayroll_FlowAccount.png',
            route.tagTitle,
            translatedMetaDescription,
          )
        } else {
          this.seoService.createMetaTag(route.tagTitle, this.translate.instant('metaDescription'))
        }
      }
    })
  }

  ngOnDestroy() {
    this.ngUnSubScribe.next(undefined)
    this.ngUnSubScribe.complete()
  }
}
